const BASE_BLUE_OPACITY = (opacity) => `rgba(64, 140, 228, ${opacity})`;

export default {
	WHITE: '#fff',
	GRAY_050: '#f6f6f6',
	GRAY_100: '#ddd',
	GRAY_200: '#bbb',
	GRAY_250: '#aaa',
	GRAY_300: '#999',
	GRAY_400: '#777',
	GRAY_500: '#666',
	GRAY_600: '#555',
	GRAY_700: '#444',
	GRAY_800: '#333',
	GRAY_850: '#222',
	GRAY_900: '#111',
	BLACK: '#000',
	LIGHT_BLUE: '#95C6FF',
	BASE_BLUE: BASE_BLUE_OPACITY(1.0),
	BASE_BLUE_OPACITY,
	DARK_BLUE: '#3A7DCC'
};
